document.addEventListener('change', function (e) {
  var sel = e.target.closest('select[name="id"]');
  if (sel) {
    var price = document.querySelector('[data-price]');
    var opt = sel.options[sel.selectedIndex];
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;
  }
  var qty = e.target.closest('[data-cart-qty]');
  if (qty) qty.form.submit();
});

document.addEventListener('DOMContentLoaded', function () {
  var stage = document.querySelector('[data-tilt-stage]');
  var card = stage && stage.querySelector('[data-tilt-card]');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!stage || !card || reducedMotion || !finePointer) return;

  stage.addEventListener('pointermove', function (event) {
    var rect = stage.getBoundingClientRect();
    var x = (event.clientX - rect.left) / rect.width;
    var y = (event.clientY - rect.top) / rect.height;
    var rotateY = (x - 0.5) * 13;
    var rotateX = (0.5 - y) * 11;
    card.style.setProperty('--tilt-x', rotateX.toFixed(2) + 'deg');
    card.style.setProperty('--tilt-y', rotateY.toFixed(2) + 'deg');
  }, { passive: true });

  stage.addEventListener('pointerleave', function () {
    card.style.setProperty('--tilt-x', '0deg');
    card.style.setProperty('--tilt-y', '0deg');
  }, { passive: true });
});
